import React, { Component } from "react";
import Update from "./Update";
import LastUpdates from "../LastUpdates/LastUpdates";
import { Link, Route } from "react-router-dom";
import { Container, Row, Col, Media } from "reactstrap";

import classes from "./LastUpdates.module.scss";
import appClasses from "../App.module.scss";

import goToTriangle from "../images/goToTriangle.png";
import mailingListSubscrib from "../images/mailingListSubscrib.png";
import leftArrow from "../images/arrowLeft.png";
import { joinCss } from "../helpers/utils";

class lastUpdates extends Component {
  constructor() {
    super();
    this.state = {
      numberOfUpdatesToDisplay: 5
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 992 || window.screen.width <= 992) {
      this.setState({ numberOfUpdatesToDisplay: 3 });
    } else {
      this.setState({ numberOfUpdatesToDisplay: 5 });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    var toReturn = (
      <Container className={classes.lastUpdates}>
        <Row className={classes.headerRow}>
          <Col lg="7" md="12" className={classes.lastUpdatesHeader}>
            פרסומים אחרונים
          </Col>
          <Col lg="5" md="12" className={classes.lastUpdatesLink}>
            <Link to={{ pathname: "/LastUpdates" }}>
              לפרסומים אחרונים נוספים
              <Media
                src={goToTriangle}
                alt="פרסומים אחרונים"
                className={appClasses.goToTriangle}
              />
            </Link>
          </Col>
        </Row>
        <Container className="px-0" className={classes.containerClass}>
          <Row>
            {this.props.updates
              .slice(0, this.state.numberOfUpdatesToDisplay)
              .map(element => (
                <Col key={"Col" + element.id} lg="4" sm="6" xs="12">
                  <Update key={element.id} update={element} />
                </Col>
              ))}
            <Col lg="4" sm="6" xs="12">
              <a
                href="#mailingListSubscrib"
                className={classes.mailingListSubscribLink}
              >
                <Container className={classes.mailingListSubscrib}>
                  <Row>
                    <Col
                      sm="12"
                      className={joinCss(
                        appClasses["center-div"],
                        classes.imgCol
                      )}
                    >
                      <Media
                        object
                        className={classes.mailingListSubscribImg}
                        src={mailingListSubscrib}
                        alt="הרשם לרשימת תפוצה"
                      />
                    </Col>
                    <Col className={classes.mailingListText}>
                      רוצה לקבל עידכונים בזמן אמת?
                      <Media
                        className={classes.leftArrow}
                        src={leftArrow}
                        alt="רשימת תפוצה"
                      />
                    </Col>
                  </Row>
                </Container>
              </a>
            </Col>
          </Row>
        </Container>
        <Route path="/LastUpdates" exact component={LastUpdates} />
      </Container>
    );
    return toReturn;
  }
}

export default lastUpdates;
